/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';
import Uppy from '@uppy/core';
import Tus from '@uppy/tus';
import swal from 'sweetalert';
import { DragDrop, ProgressBar, StatusBar } from '@uppy/react';
import '@uppy/core/dist/style.css';
import '@uppy/drag-drop/dist/style.css';
import '@uppy/progress-bar/dist/style.css';
import '@uppy/status-bar/dist/style.css';
import { loadState } from '../../../store/sessionStore'

export const getHeaders = () => {
  const { apiToken } = loadState();
  const header = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };
  if (apiToken !== undefined) {
    header.Authorization = `Bearer ${apiToken}`;
  }
  return header;
};

class UploadDragAndDrop extends React.Component {

  constructor(props) {
    super(props);
    this.state = { enableDragAndDrop: true, numberOfUploads: 0 };

    this.showError = (error) => {
      const message = error.message ? error.message : 'This file can not be uploaded!';
      swal('Error', message, 'error');
    };
    this.greatestCommonDivisor = (a, b) => {
      return (b == 0) ? a : this.greatestCommonDivisor(b, a%b);
    }
    let customTypes=null;
    if(this.props.fileType=="image/*"){
      customTypes=['.jpeg', '.jpg','.png'];
    }
    this.uppy = Uppy({
      autoProceed: true,
      allowMultipleUploads: true,
      restrictions: {
        maxNumberOfFiles: this.props.numberOfFiles,
        allowedFileTypes:(customTypes?customTypes:this.props.fileType)
      },
      onBeforeFileAdded: (currentFile, files) => {
        const modifiedFile = {
          ...currentFile,
          name: currentFile.name.replaceAll(/[^a-zA-Z0-9.]/g, ''),
        };
        // console.log(modifiedFile);
        return modifiedFile;
      },
    });

    this.uppy.use(Tus, {
      endpoint: process.env.REACT_APP_BACKEND_URL
      + process.env.REACT_APP_UPLOAD_ENDPOINT,
      headers: {
        Authorization: getHeaders()['Authorization'],
      },
      chunkSize: 5000000,
      onChunkComplete: (chunkSize, bytesAccepted, bytesTotal) => {
        // console.log('onChunkComplete', chunkSize, bytesAccepted, bytesTotal);
      },
    });

    this.uppy.on('complete', (result) => {
      const oldState = this.state;

      oldState.numberOfUploads -= 1;
      if (oldState.numberOfUploads <= 0) {
        oldState.numberOfUploads = 0;
        this.props.onCompleted(result);
        this.setState({ ...oldState, enableDragAndDrop: this.props.enableManyTimes });
      } else {
        this.setState({ ...oldState });
      }
    });
    this.uppy.on('file-added', (file) => {
      if(props.allowedSizes || process.env.REACT_APP_DISABLE_CHECK_IMAGE_RESOLUTIONS=="true"){
        const data = file.data // is a Blob instance
        const url = URL.createObjectURL(data)
        const image = new Image()
        image.src = url
        image.onload = () => {
          const { width, height } = image;
          let matchesAllowedSize = true;
          if(process.env.REACT_APP_DISABLE_CHECK_IMAGE_RESOLUTIONS=="false"){
            matchesAllowedSize = true;
          }else{
            matchesAllowedSize = props.allowedSizes.some(
              (size) => size.width === width && size.height === height
            );
          }

          if (!matchesAllowedSize) {
            const allowedDescriptions = props.allowedSizes.map(
              (size) => `${size.width}x${size.height}`
            );

            const message = `The image size should be one of: ${allowedDescriptions.join(" or ")}`;
            this.showError({ message });
            this.uppy.cancelAll();
          }
          this.uppy.setFileMeta(file.id, { width: image.width, height: image.height })
          URL.revokeObjectURL(url)
        }
      }
      if(props.aspectRatio || process.env.REACT_APP_DISABLE_CHECK_IMAGE_RESOLUTIONS=="true"){
        const data = file.data // is a Blob instance
        const url = URL.createObjectURL(data)
        const image = new Image()
        image.src = url
        image.onload = () => {
          let gcd = this.greatestCommonDivisor(image.width,image.height);
          
          let imageAspectRatio = (image.width/gcd) + ':' + (image.height/gcd);
          if(process.env.REACT_APP_DISABLE_CHECK_IMAGE_RESOLUTIONS=="false"){
            imageAspectRatio = props.aspectRatio;
          }
          if( imageAspectRatio !== props.aspectRatio ){
            this.showError({message:'The file should be of aspect ratio ' + props.aspectRatio});
            this.uppy.cancelAll();
          }
          if(props.imageHeight && props.imageWidth && (image.width !== props.imageWidth) && (image.height !== props.imageHeight)){
            this.showError({message:'The image should be of height: ' + props.imageHeight + ' and width: ' + props.imageWidth});
            this.uppy.cancelAll();
          }
          this.uppy.setFileMeta(file.id, { width: image.width, height: image.height })
          URL.revokeObjectURL(url)
        }
        
      }      

    });
    
    this.uppy.on('cancel-all', (result) => {
      const oldState = this.state;
      oldState.numberOfUploads = 0;
      this.setState({ ...oldState });
      this.props.onCanceled(result);
    });

    this.uppy.on('upload', (result) => {
      const oldState = this.state;

      if (oldState.numberOfUploads === 0) {
        this.props.onUpload(result);
      }
      oldState.numberOfUploads += 1;
      this.setState({ ...oldState });
    });

    this.uppy.on('upload-error', (file, error) => {
      this.showError(error);
      this.props.onError(file, error);
    });

    this.uppy.on('error', (error) => {
      this.showError(error);
    });

    this.uppy.on('restriction-failed', (file, error) => {
      this.showError(error);
    });

    this.uppy.on('upload-success', (file, result) => {
      this.props.onUploaded(file, result);
    });

    this.removeBackgroundFile = (fileId) => {
      this.uppy.removeFile(fileId);
    };
  }

  componentWillUnmount() {
    this.uppy.close();
  }

  render() {
    return (
      <div {...(this.props.id && this.props.id != '' ? { id: this.props.id } : {})} className={this.props.className}>
        {this.state.enableDragAndDrop === true
        && (
        <DragDrop
          uppy={this.uppy}
          locale={{
            strings: {
              // Text to show on the droppable area.
              // `%{browse}` is replaced with a link that opens the system file selection dialog.
              dropHereOr: 'Drop here or %{browse}',
              // Used as the label for the link that opens the system file selection dialog.
              browse: 'browse',
            },
          }}
        />
        )}

        <ProgressBar uppy={this.uppy} />
        <StatusBar uppy={this.uppy} />
      </div>
    );
  }
}

UploadDragAndDrop.propTypes = {
  /**
   * id of upload async
   */
  id: PropTypes.string,
  /**
   * Completed event function
   */
  onCompleted: PropTypes.func,
  /**
   * Error event function
   */
  onError: PropTypes.func,
  /**
   * Fired when upload starts.
   */
  onUpload: PropTypes.func,
  /**
   * Fired when a file was loaded
   */
  onUploaded: PropTypes.func,
  /**
   * Fierd when all uploads are caceled
   */
  onCanceled: PropTypes.func,
  /**
   * Format of the accepted files
   */
  fileType: PropTypes.arrayOf((PropTypes.string)),
  /**
   * Number of files accepted
   */
  numberOfFiles: PropTypes.number,
  /**
   * Allow upload many times
   */
  enableManyTimes: PropTypes.bool,
  /**
   * Custom Class
   */
  className: PropTypes.string,
};

UploadDragAndDrop.defaultProps = {
  id: '',
  onCompleted: () => {},
  onError: () => {},
  onUpload: () => {},
  onUploaded: () => {},
  onCanceled: () => {},
  fileType: '',
  numberOfFiles: 1,
  enableManyTimes: false,
  className: '',
};

export default UploadDragAndDrop;
